module.exports = __webpack_public_path__ + "static/img/GH_H5.51a319b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/GH_H5.png
// module id = libv
// module chunks = 34